import { useEffect, useState } from "react";

export const useMediaQuery = (query?: string): boolean => {
  const queryString = query || "(min-width: 1025px)";
  const getMatch = (q: string): boolean =>
    typeof window !== "undefined" ? window.matchMedia(q).matches : false;

  const [matches, setMatches] = useState<boolean>(() => getMatch(queryString));

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQueryList = window.matchMedia(queryString);

    const handleChange = () => {
      setMatches(mediaQueryList.matches);
    };

    handleChange();

    mediaQueryList.addEventListener?.("change", handleChange);
    return () => mediaQueryList.removeEventListener?.("change", handleChange);
  }, [queryString]);

  return matches;
};
